<template>
  <div class="announcement-carousel">
    <!-- 公告容器 -->
    <div class="carousel-container" @mouseenter="pauseAutoPlay" @mouseleave="startAutoPlay">
      <div style=" height: 100%; float: left; ">
   <img src="@/assets/images/gonggao.png" alt="" style="width: 0.1rem; margin-top: 0.06rem; margin-left: 0.1rem;">
      </div>
   
      <div 
        class="announcement-list "
        :class="flage ? 'announcement-listno' : ''"
        :style="{ transform: `translateX(-${currentIndex * 100}%)` }"
      >
        <div 
          v-for="(item, index) in announcements" 
          :key="index"
          class="announcement-item"
          @click="goTo(item.path)"
          style=" cursor: pointer;"
        >
          {{ item.content }}
        </div>
        <div 
          class="announcement-item"
          v-if="announcements.length > 1"
           @click="goTo(announcements[0].path)"
        >
        
          {{ announcements[0].content }}
        </div>
      </div>

      <!-- 控制按钮 -->
      <button class="control-btn prev" @click="prev">‹</button>
      <button class="control-btn next" @click="next">›</button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      currentIndex: 0,
      autoPlayTimer: null,
      flage:false,
      announcements: [
        { content: 'AMD AI PC 应用创新大赛火热报名中，报名参赛，赢取奖金，获奖率高！' , path:'/AMDAIPC2025'},
      ]
    }
  },
  methods: {
    next() {
      if(this.announcements.length === 1)return
      // this.currentIndex = (this.currentIndex + 1) % this.announcements.length
      if (this.currentIndex === this.announcements.length && this.announcements.length > 1) {
        this.flage=true
        this.currentIndex++;
        this.currentIndex = 0;
      } else {
        this.flage=false
        this.currentIndex++;
      }
    },
    prev() {
      this.currentIndex = (this.currentIndex - 1 + this.announcements.length) % this.announcements.length
    },
    goTo(index) {
      this.currentIndex = index
    },
    startAutoPlay() {
      if(this.announcements.length > 1){
        this.autoPlayTimer = setInterval(this.next, 3000)
      }
 
    },
    pauseAutoPlay() {
      clearInterval(this.autoPlayTimer)
    },
    goTo(item){
      this.$router.push(item)
    }
  },
  mounted() {
    this.startAutoPlay()
  },
  beforeDestroy() {
    clearInterval(this.autoPlayTimer)
  }
}
</script>

<style scoped>

.announcement-carousel {
  width: 100%;
  font-size: 18px !important;
  font-weight: bold;
  margin: 0 auto;
  position: relative;
}

.carousel-container {
  position: relative;
  overflow: hidden;
  border-radius: 8px;
  height: 0.24rem;
}

.announcement-list {
  display: flex;
  transition: transform 0.5s ease-in-out;
  height: 100%;
 
}
.announcement-listno{
  transition: transform 0s ease-in-out !important; 
}
.announcement-item {
  flex: 0 0 100%;
  box-sizing: border-box;
  font-size: 16px;
  color: #333;
  display: flex;
  align-items: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-left: 0.06rem;
}

.control-btn {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background: rgba(0,0,0,0.3);
  color: white;
  border: none;
  padding: 10px 15px;
  cursor: pointer;
  border-radius: 4px;
  transition: background 0.3s;
  display: none;
}
.carousel-container:hover .control-btn {
  display: block;
}
.control-btn:hover {
  background: rgba(0,0,0,0.6);
}

.prev {
  left: 10px;
}

.next {
  right: 10px;
}

.indicators {
  text-align: center;
  margin-top: 10px;
}

.indicators span {
  display: inline-block;
  width: 10px;
  height: 10px;
  margin: 0 5px;
  border-radius: 50%;
  background: #ddd;
  cursor: pointer;
  transition: background 0.3s;
}

.indicators span.active {
  background: #666;
}

</style>